import Vue from 'vue';

// import axios from 'axios';
// const TITAN = process.env.TITAN || 'http://localhost:3034';
//
// const apiClient = axios.create({
//   baseURL: `${TITAN}`,
//   headers: {
//     Accept: 'application/json',
//     'Content-Type': 'application/json'
//   }
// });
export default {
  // refresh auth data set, requires valid bearer token
  async getToken() {
    try {
      return await Vue.axios.get('/token');
    } catch (error) {
      console.log('getToken error:', error.message);
      throw error;
    }
  },
  // refresh auth
  async refreshToken(refreshData) {
    try {
      return Vue.axios.post('/refresh', refreshData);
    } catch (error) {
      console.log('refreshToken error:', error);
      throw error;
    }
  },
  // login with username, password and teamId
  async login(credentials) {
    try {
      return await Vue.axios.post('/login', credentials);
    } catch (error) {
      console.log('login error:', error.message);
      throw error;
    }
  },
  // gets current user
  async getUser() {
    try {
      return Vue.axios.get('/api/user');
    } catch (error) {
      console.log('getUser error:', error.message);
      throw error;
    }
  }, // gets current user IP
  async getUserIP() {
    try {
      return await Vue.axios.get('/api/user/ip');
    } catch (error) {
      console.log('getUserIP error:', error.message);
      throw error;
    }
  },
  // gets current team
  async getTeam() {
    try {
      return await Vue.axios.get('/api/team');
    } catch (error) {
      console.log('getTeam error:', error.message);
      throw error;
    }
  },
  async getAccount() {
    try {
      return await Vue.axios.get('/account');
    } catch (e) {
      console.log('getAccount error:', e.message);
      throw e;
    }
  },
  async getDownloads() {
    try {
      return await Vue.axios.get('/api/downloads');
    } catch (e) {
      console.log('getDownloads error:', e.message);
      throw e;
    }
  },
  async getKeys() {
    try {
      return await Vue.axios.get('/api/keys');
    } catch (e) {
      console.log('getKeys error:', e.message);
      throw e;
    }
  },
  async getGroups() {
    try {
      return await Vue.axios.get('/api/group');
    } catch (e) {
      console.log('getGroups error:', e.message);
      throw e;
    }
  },
  async updateGroup(groupId, data) {
    try {
      return await Vue.axios.patch(`/api/group/${groupId}`, data);
    } catch (e) {
      console.log('updateGroup error:', e.message);
      throw e;
    }
  },
  async deleteGroup(groupId) {
    try {
      return await Vue.axios.delete(`/api/group/${groupId}`);
    } catch (e) {
      console.log('deleteGroup error:', e.message);
      throw e;
    }
  },
  async signup(newSignup) {
    try {
      return await Vue.axios.post('/signup', newSignup);
    } catch (error) {
      console.log('signupUser error:', error.message);
      throw error;
    }
  },
  async changePlan(subscription_id, plan_id) {
    // these fields are specific to Paddle
    try {
      return await Vue.axios.post('/account/paddle/update', {
        subscription_id,
        plan_id
      });
    } catch (error) {
      console.log('changePlan error:', error.message);
      throw error;
    }
  },
  async getHistory() {
    // these fields are specific to Paddle
    try {
      return await Vue.axios.get('/account/paddle');
    } catch (error) {
      console.log('getHistory error:', error.message);
      throw error;
    }
  },
  async updateProfile(userId, userProfile) {
    try {
      return await Vue.axios.patch(`/api/user/${userId}`, userProfile);
    } catch (error) {
      console.log('updateProfile error:', error.message);
      throw error;
    }
  },
  async updateTeamProfile(teamId, teamProfile) {
    try {
      return await Vue.axios.patch(`/api/team/${teamId}`, teamProfile);
    } catch (error) {
      console.log('updateTeamProfile error:', error.message);
      throw error;
    }
  },
  async updatePassword(passwordDetails) {
    try {
      return await Vue.axios.post('/api/user/password', passwordDetails);
    } catch (error) {
      console.log('updatePassword error:', error.message);
      throw error;
    }
  },
  async forgotPassword(passwordDetails) {
    try {
      return await Vue.axios.post('/forgot', passwordDetails);
    } catch (error) {
      console.log('forgotPassword error:', error.message);
      throw error;
    }
  },
  async resetPassword(passwordDetails) {
    try {
      return await Vue.axios.post(`/reset/${passwordDetails.forgotId}`, {
        password: passwordDetails.password
      });
    } catch (error) {
      console.log('resetPassword error:', error.message);
      throw error;
    }
  },
  async verifyEmail(emailDetails) {
    try {
      return await Vue.axios.get(
        `/verified/${emailDetails.userId}?email=${encodeURIComponent(
          emailDetails.email
        )}$inApp=1`
      );
    } catch (error) {
      console.log('verifyEmail error:', error.message);
      throw error;
    }
  },
  async sendVerificationEmail(emailDetails) {
    try {
      // console.log('sendVerification:', emailDetails);
      return await Vue.axios.get(`/verify/${emailDetails.userId}`);
    } catch (error) {
      console.log('sendVerificationEmail error:', error.message);
      throw error;
    }
  },
  async getInvitations() {
    try {
      return await Vue.axios.get('/api/team/get/invites');
    } catch (error) {
      console.log('getInvitations error:', error.message);
      throw error;
    }
  },
  async deleteInvitation(inviteId) {
    try {
      return await Vue.axios.delete(`api/team/delete/invite/${inviteId}`);
    } catch (error) {
      console.log('deleteInvitation error:', error.message);
      throw error;
    }
  },
  async sendInvitation(email) {
    try {
      return await Vue.axios.post('api/team/send/invite', {
        email
      });
    } catch (error) {
      console.log('sendInvitation error:', error.message);
      throw error;
    }
  },
  async leaveTeam({ teamId, userId }) {
    try {
      return await Vue.axios.post(`api/team/${teamId}/leave`, {
        userId
      });
    } catch (error) {
      console.log('sendInvitation error:', error.message);
      throw error;
    }
  }
};
